/*
 * @Author: DYM
 * @Date: 2020-08-11 12:02:07
 * @LastEditors: zxf
 * @LastEditTime: 2022-03-28 10:43:17
 * @Description: 图表配置信息
 */
const chartConfig = {
  color: ['#9af1c5', '#ffd67d', '#ff7d7d', '#C0C4CC', '#bda29a', '#6e7074', '#546570', '#c4ccd3', '#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83']
};

export default chartConfig;
